import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { AuthorizationService } from '../../services/authorization.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authorization: AuthorizationService,
    private cookieService: CookieService
  ) {}
  // canLoad(route: Route): boolean {
  //     return this.canActivate();
  //   }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.getCookie('id_token')) {
      return true;
    }
    this.authorization.getSecured(state.url);
    return false;
  }

  getCookie(key: string): string {
    return this.cookieService.get(key);
  }
}
